import { Refunds } from "modules/financial";

const RefundsPage = () => {
  return <Refunds />;
};

export default RefundsPage;
